<template>
  <Transition name="fade">
    <div v-if="showing" class="z-999 fixed inset-0 w-full h-screen flex items-center justify-center bg-overlay" @click.self="close">
      <div class="relative max-h-screen w-full max-w-2xl">
        <div class="overflow-auto max-h-screen w-full">
          <l-container :nocontent="false" class="mb-4">
            <l-container-title slot="toolbar" :text="text" :icon="icon" :color="color"  />
            <div>
              <slot />
            </div>
          </l-container>
        </div>      
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: "LModal",
  props: ["showing", "text", "icon", "color"],
  watch: {
    showing(value) {
      if (value)
        return document.querySelector("body").classList.add("overflow-hidden");
      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.z-999 {
  z-index: 999;
}

.bg-overlay {
  background: rgba(0, 0, 0, 0.4);
}
</style>